import React from 'react'
import { Flex, Text, Box, Skeleton, SkeletonLine, SkeletonCircle } from '@chilipiper/design-system'
import { Avatar } from '@chilipiper/design-system/src/new'
import { useTranslations } from '../../../../context/TranslationContext'

type Props = {
  assignee?: { id: string; image?: string; name: string }
  displayName?: string
  state: 'scheduling' | 'rescheduling' | 'scheduled'
}

export const ScheduleHeader = ({ displayName, assignee, state }: Props) => {
  const [pickTimeWithText, pickNewTimeWith, bookedWith] = useTranslations([
    'pickTimeWithText',
    'pickNewTimeWith',
    'bookedWith',
  ])
  return (
    <Flex
      px={5}
      py={4}
      flexDirection={state === 'scheduled' ? 'column' : undefined}
      alignItems='center'
      gap={state === 'scheduled' ? 2 : 4}
    >
      <Assignee assignee={assignee} state={state} />
      <Box>
        <Text
          display='block'
          color='fg/moderate'
          textStyle='detail-m'
          mb={1}
          textAlign={state === 'scheduled' ? 'center' : undefined}
        >
          {state === 'scheduling' && pickTimeWithText}
          {state === 'rescheduling' && pickNewTimeWith}
          {state === 'scheduled' && bookedWith}
        </Text>
        {displayName !== undefined ? (
          <Text
            display='block'
            color='fg/major'
            textStyle='page-section-heading'
            textAlign={state === 'scheduled' ? 'center' : undefined}
          >
            {displayName}
          </Text>
        ) : (
          <Skeleton height={14} width={100}>
            <SkeletonLine y={6} width={100} />
          </Skeleton>
        )}
      </Box>
    </Flex>
  )
}

const Assignee = ({
  assignee,
  state,
}: {
  assignee?: {
    id: string
    image?: string
    name: string
  }
  state: 'scheduling' | 'rescheduling' | 'scheduled'
}) => {
  if (!assignee) {
    return (
      <Skeleton width={32} height={32}>
        <SkeletonCircle cx={16} cy={16} r={16} />
      </Skeleton>
    )
  }

  return (
    <Avatar
      id={assignee.id}
      name={assignee.name}
      size={state === 'scheduled' ? 10 : 7}
      image={assignee.image}
    />
  )
}
